import createContext from 'zustand/context';
import { QueryBuilderStateWithRedux } from './types';
import { StoreApi } from 'zustand';

export const QueryBuilderContext =
  createContext<StoreApi<QueryBuilderStateWithRedux>>();
